import React from 'react';
import styles from '../lsx_agrofert/lsx_agrofert.module.scss';
import Perfil from './src/perfil.png';
import LinkPersonalizado8 from '../../components/LinkPersonalizado8/linkPersonalizado8.tsx';

const Lsx_agrofert: React.FC = () => {

    return (
        <div className={styles.lsx_agrofert}>
            <div className={styles["body-thunder"]}>
                <div className={`${styles["container-thunder"]}`} >
                    <img
                        className={styles["img-perfil"]}
                        src={Perfil}
                        alt="Profile Picture"
                    />
                    <div className={styles.links}>
                        <LinkPersonalizado8
                            href="https://wa.me/5517996236770?text=Olá, gostaria de mais informações."
                            title="CONTATO"
                            colorText="#FFFFFF"
                            backgroundColor="#037f36"
                            backgroundColorHover="#04612a"
                        />
                        <LinkPersonalizado8
                            href="https://maps.app.goo.gl/9n6XAfE5Joi7k7Yj7"
                            title="LOCALIZAÇÃO"
                            colorText="#FFFFFF"
                            backgroundColor="#037f36"
                            backgroundColorHover="#04612a"
                        />
                        <LinkPersonalizado8
                            href="mailto:lsxagrofert@lsxagrofert.com.br?subject=Informações&body=Olá, gostaria de mais informações."
                            title="E-MAIL"
                            colorText="#FFFFFF"
                            backgroundColor="#037f36"
                            backgroundColorHover="#04612a"
                        />
                        <LinkPersonalizado8
                            href="https://www.lsxagrofert.com.br"
                            title="SITE"
                            colorText="#FFFFFF"
                            backgroundColor="#037f36"
                            backgroundColorHover="#04612a"
                        />
                        <LinkPersonalizado8
                            href="https://www.linkedin.com/company/lsx-agrofert/"
                            title="LINKEDIN"
                            colorText="#FFFFFF"
                            backgroundColor="#037f36"
                            backgroundColorHover="#04612a"
                        />
                        <LinkPersonalizado8
                            href="https://www.youtube.com/@lsxholding"
                            title="YOUTUBE"
                            colorText="#FFFFFF"
                            backgroundColor="#037f36"
                            backgroundColorHover="#04612a"
                        />
                        <LinkPersonalizado8
                            href="https://www.instagram.com/lsx_agrofert?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                            title="INSTAGRAM"
                            colorText="#FFFFFF"
                            backgroundColor="#037f36"
                            backgroundColorHover="#04612a"
                        />
                    </div>
                </div>
            </div>
        </div >
    );
};

export default Lsx_agrofert;
